// Components
export const HEADER: string = "Header";
export const JOB_SEARCH_VIEW: string = "JobSearchView";
export const JOB_SEARCH_RESULTS_VIEW: string = "JobSearchResultsView";
export const JOB_SEARCH_RESULTS_GRID: string = "JobSearchResultsGrid";
export const TIME_RANGE_SELECTOR: string = "TimeRangeSelector";

// Component Instances
export const OPTIONS: string = "options";

export const ENABLED_MODULES_CONFIGURATION_KEY = "EnabledModule";
export const MODULE_GROUP_CONFIGURATION_KEY = "Module";

export const MANUAL_JOB_VIEW: string = "ManualJobView";
export const MEMBERS_PORTAL_HOME_PAGE: string = "MembersPortalHomePage";

// Job Types
export const BOOK_EXPORT_JOB_TYPE: string = "BEXP";
export const CWR_GENERATION_JOB_TYPE: string = "CWRG";
export const DRAFT_AGREEMENT_SUBMISSION_JOB_TYPE: string = "DRAFTAGR";
export const CWR_ACK2_JOB_TYPE: string = "CWRACK2";
export const AAG_JOB_TYPE: string = "AAG";
export const ATF_JOB_TYPE: string = "ATF";
export const UNIDENTIFIED_PERFORMANCE_JOB_TYPE: string = "UP";
export const UNDISTRIBUTED_SHARES_JOB_TYPE: string = "UDS";
export const PD_RULES_JOB_TYPE: string = "PD";
export const CISNet_JOB_TYPE: string = "CISNet";
export const CISNet2_JOB_TYPE: string = "CISNet2";
export const SUSPENSE_RELEASE_JOB_TYPE: string = "SR";
export const MECHANICAL_BACKCLAIM_JOB_TYPE: string = "MBC";
export const GENERATE_STATEMENT_DETAILS_JOB_TYPE: string = "GSD";
export const GENERATE_PAYMENT_DETAILS_JOB_TYPE: string = "GPD";
export const POST_STATEMENTS_ON_PORTAL_JOB_TYPE: string = "PSOP";
export const MANUAL_USAGE_MATCHING_JOB_TYPE: string = "USGM";
export const MANUAL_UNDO_USAGE_INGESTION_JOB_TYPE: string = "UUI";
export const RESET_DISTRIBUTION_CACHE_JOB_TYPE: string = "RDC";
export const EXTRACT_MATCHED_USAGE_WORKS_JOB_TYPE: string = "EMUW";
export const CLAIM_JOB_TYPE: string = "CLAIM";
export const GENERATE_BUSINESS_CENTRAL_PAYMENT_JOB_TYPE: string = "GBCP";
export const BOOK_CLAIM_SUSPENSE_RELEASE_JOB_TYPE: string = "BCSR";
export const AVI_SUBMISSION_JOB_TYPE: string = "CISAVI";
export const BATCH_CONSOLIDATION_JOB_TYPE: string = "BCON";
export const USAGE_TO_LICENSE_MATCHING_JOB_TYPE: string = "ULM";
export const PRE_ALLOCATION_JOB_TYPE: string = "PREALK";
export const INVOICE_EXPORT_JOB_TYPE: string = "INVEX";
export const CONTRIBUTORS_MASS_UPDATE_JOB_TYPE: string = "CMU";
export const ICE_BATCH_SHARE_JOB_TYPE: string = "IBS";
export const DELTA_TABLE_SYNC_JOB_TYPE: string = "DTS";
export const INVOICE_DISPUTES_PROCESSING_JOB_TYPE: string = "IDP";
export const ESI_GENERATION_JOB_TYPE: string = "ESI";
export const GENERATE_USAGE_ALLOCATION_DETAILS_JOB_TYPE: string = "GUAD";
export const APPLY_COMMISSIONS_POST_ALLOCATIONS_JOB_TYPE: string = "ALKCOM";
export const CLEANUP_INTRAY_CUE_JOB_TYPE: string = "CIC";
export const ZERO_SHARE_WORKS_JOB_TYPE: string = "ZER";
export const BMAT_CUE_SHEET_EXTRACT_JOB_TYPE: string = "BMATCSE";

// Keys
export const DEADLINE_DATE_KEY: string = "Deadline Date";
export const DISTRIBUTION_DATE_KEY: string = "Distribution Date";
export const USAGE_DATE_FROM_KEY: string = "Usage Date from";
export const USAGE_DATE_TO_KEY: string = "Usage Date to";
export const MINIMUM_THRESHOLD_KEY: string = "Minimum Threshold";
export const HIGH_WATER_MARK_KEY: string = "HighWaterMark";
export const DISPLAY_CUSTOMER_LOGO_KEY = "DisplayCustomerLogo";
export const STATEMENT_FORMAT_FIELD_KEY: string = "statementFormat";
export const PAYMENTRUN_ID_FIELD_KEY: string = "paymentRunID";
export const CREATED_FROM_KEY: string = "Created From:";
export const CREATED_TO_KEY: string = "Created To:";
export const FORMAT_KEY: string = "format";
export const DISTRIBUTION_KEY: string = "distributionCode";
export const POOL_KEY: string = "pool";
export const INVOICE_NUMBER_KEY: string = "invoiceNumber";

//labels
export const OUTPUT_TYPE_TITLE: string = "Output Type";
export const HIGH_WATER_MARK_TITLE: string = "High Water Mark";
export const FORMAT_TITLE: string = "Format";
export const DISTRIBUTION_TITLE: string = "Distribution";
export const DISTRIBUTION_TITLE_PLURAL: string = "Distributions";
export const POOL_TITLE: string = "Pool";
export const CREATE_MANUAL_JOB_TITLE: string = "Create Manual Job";
export const INVOICE_NUMBER_TITLE: string = "Invoice Number";
export const PACKAGE_ID : string = "Package ID";
export const TRANSFER_RELATIONSHIP_TITLE: string = "Transfer Relationships";
export const PACKAGE_TERRITORY : string = "Territory";
export const PACKAGE_SHARE_SET : string = "Share Set";
export const UPDATE_AGREEMENT_ASSIGNEES : string = "Update Agreements";

//Configuration parameters
export const CEDRO_CUSTOMER_NAME = "CEDRO";
export const ARTISJUS_CUSTOMER_NAME = "Artisjus";
export const SPANISH_POINT_CUSTOMER_NAME = "SpanishPoint";
export const IMRO_CUSTOMER_NAME = "IMRO";
export const TEOSTO_CUSTOMER_NAME = "TEOSTO";
export const KODA_CUSTOMER_NAME = "KODA";
export const TONO_CUSTOMER_NAME = "TONO";
export const POLARIS_CUSTOMER_NAME = "Polaris";
export const SIAE_CUSTOMER_NAME = "SIAE";
export const SOCAN_CUSTOMER_NAME = "SOCAN";
export const CUSTOMER_KEY = "Customer";
export const CUSTOMER_GROUP = "CustomerConfiguration";
export const ALLOCATION_CONFIGURATION = "Allocation";
export const CUSTOMER_DATE_KEY = "CustomerDate";
export const IS_USAGE_TAB_DEFAULT_SET_TO_MATCH = "IsUsageTabDefaultSetToMatch";
export const CUSTOMER_NAMES_TYPES_KEY = "CustomerNamesTypes";
export const CONTRIBUTOR_TYPES_KEY = "ContributorTypes";
export const ENABLE_CATCHUP_ALLOCATIONS_CONFIGURATION = "EnableCatchupAllocations";
export const CUSTOMER_TIME_ZONE = "CustomerTimeZone";
export const CUSTOMER_LOGOS_KEY = "CustomerLogos";
export const CRM_INTEGRATED_KEY = "IsCRMIntegrated";
export const POWER_PORTAL_BASE_URL_KEY = "PowerPortalBaseUrl";
export const CUSTOMER_DEFAULT_TERRITORIES = "DefaultTerritory";
export const SEPARATE_PUBLISHED_CHECKBOX = "SeparatePublishedCheckbox";
export const CWRG_GROUP = "CWRGenerationJob";
export const USAGE_MAINTENANCE_KEY = "UsageNumberInSearch";
export const USAGE_MAINTENANCE_NAME = "UsageMaintenance";
export const MEMBER_NUMBER_KEY = "EnableMemberNumber";
export const GET_ROLL_UP_TERRITORIES_KEY = "EnableRollUpTerritories";
export const JOB_GROUP = "Job";
export const DISTRIBUTION_SELECTION_CRITERIA_COPY_KEY = "EnableDistributionSelectionCriteriaCopy";
export const ADJUSTMENT_ICE_WORK_SEARCH_KEY = "EnableAdjustmentICEWorkSearch";
export const CUSTOMER_TERRITORY = "CustomerTerritory";
export const ENABLE_SET_TYPE_BUNDLE_KEY = "EnableSetTypeBundle";
export const POWER_BI_ANALYTICS_CONFIGURATION_KEY = "PowerBIAnalyticsReport";
export const ENABLE_POWER_BI_EMBEDDED_KEY = "EnablePowerBIEmbedded";
